import { StatsigClient } from '@statsig/js-client';

// TODO: source from secret manager
const STATSIG_CLIENT_KEY = 'client-1Ia1UqJMox8AExqR1nmRr8jcfufau6Ly3ePYb4cp35x';

const DEBUG = false;

let client = null;

const statsig = {
    async init(user = {}) {
        const statsig_user = { userID: user.userID || 'anonymous', ...user };
        if (client) {
            await client.updateUserAsync(statsig_user);
        } else {
            client = new StatsigClient(
                STATSIG_CLIENT_KEY,
                statsig_user,
                { environment: { tier: app.dev_env ? 'development' : 'production' } }
            );
            await client.initializeAsync();
        }
        app.trigger(app.events.STATSIG_READY);
    },

    log_event(name, value = null, metadata = {}) {
        if (!client) return;
        client.logEvent(name, value, metadata);
        DEBUG && console.log(`[statsig] log_event:`, { name, value, metadata });
    },

    // The user the SDK evaluates with, including its stableID, for the backend to evaluate the same assignment.
    get_user() {
        if (!client) return null;
        const { user, stableID } = client.getContext();
        return { ...user, customIDs: { ...user.customIDs, stableID } };
    },

    // quiet: look up the assignment without it counting as an exposure.
    get_assignments(experiment_keys, { quiet = false } = {}) {
        // getExperiment() before the client is Ready (initial load or user update) evaluates against
        // empty values and logs a bogus default-group exposure; STATSIG_READY re-triggers the lookup.
        if (client?.loadingStatus !== 'Ready') return {};
        return experiment_keys.reduce((acc, key) => {
            const exp = client.getExperiment(key, { disableExposureLog: quiet });
            DEBUG && console.log(`[statsig] get_assignments ${key}:`, { value: exp.value, groupName: exp.groupName, exp, v: exp.get('v', null), variant: exp.get('variant', null) });
            // Prefer an explicit 'variant' parameter; fall back to the group name.
            const variant = exp.get('v', null) ?? exp.groupName ?? null;
            if (variant) acc[key] = variant;
            return acc;
        }, {});
    },

    // NOTE: getConfigList() returns hashed numeric IDs, not human-readable experiment names.
    // Statsig hashes names in its CDN response — there is no way to reverse them.
    // Auto-discovery of all experiment names is not possible with this SDK.
    // Use get_assignments(keys) with known names from site_status.exprms instead.
    get_all_assignments() {
        if (!client) return {};
        try {
            // hashes → variant; keys are numeric hash strings, NOT readable names.
            const hashes = client.getConfigList?.() ?? [];
            return hashes.reduce((acc, hash) => {
                const variant = client.getExperiment(hash).get('variant', null);
                if (variant) acc[hash] = variant;
                return acc;
            }, {});
        } catch (e) {
            console.error('statsig get_all_assignments failed:', e);
            return {};
        }
    },

    // Call ( _statsig.debug() ) in the browser console to inspect the internal client structure.
    // Use this to find the correct path for get_all_assignments() if it returns empty.
    debug() {
        if (!DEBUG) { console.warn('Statsig hello'); return; }
        if (!client) { console.warn('Statsig: client not initialised'); return; }
        console.group('Statsig client internals');
        console.log('top-level keys:', Object.keys(client));
        for (const key of Object.keys(client)) {
            try { console.log(key, ':', client[key]); } catch { /* skip non-enumerable */ }
        }
        console.log('getConfigList():', client.getConfigList?.());
        console.log('_store:', client._store);
        console.log('_store keys:', client._store && Object.keys(client._store));
        console.log('_dataAdapter:', client._dataAdapter);
        console.log('_evaluator:', client._evaluator);
        // Dump anything that looks like it holds configs
        const candidates = ['_store', '_cache', '_dataAdapter', '_evaluationsDataAdapter'];
        for (const c of candidates) {
            if (client[c]) {
                console.log(`${c}.values:`, client[c].values);
                console.log(`${c}._store:`, client[c]._store);
                console.log(`${c} keys:`, Object.keys(client[c]));
            }
        }
        console.groupEnd();
    },
};

// if (__RUN_MODE__ === 'loc') {
//     window._statsig = statsig;
// }
 globalThis._statsig = statsig;

export default statsig;
